import { mapGetters } from 'vuex';

import { FavoriteSelectBookMixin } from '@/mixins/Bookmark/FavoriteSelectBook';

export default {
  name: 'SelectBookMenu',

  mixins: [FavoriteSelectBookMixin],

  computed: {
    ...mapGetters('Mixins/Bookmark', {
      mg_isSelectedCourse: 'isSelectedCourse',
      mg_selectedBookName: 'selectedBookName',
    }),
  },
};
